const getNextAvailableTitle = (title, data = [], dataKey = "name") => {
  if (!data.length || !data.find((d) => d[dataKey] === title)) {
    return title;
  }

  const escaped = title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`^${escaped} \\((\\d*)\\)$`);
  const matches = data.filter((d) => d[dataKey]?.match(regex));

  if (matches.length === 0) {
    return `${title} (1)`;
  }

  const highest = matches.reduce(
    (max, d) => Math.max(max, Number(d[dataKey].match(regex)[1])),
    0
  );
  return `${title} (${highest + 1})`;
};

export default getNextAvailableTitle;
